<script lang="ts">
  // lib
  import { Alert, TaskPanel, DrawerTrigger, Text, Heading } from "@getprovi/craft-svelte";
  import { MegaphoneSolid } from "@getprovi/craft-svelte-icons";
  import moment from "moment";

  // services
  import { EventTracking } from "@shared/services/event_tracking/events";
  import CloudinaryImageService from "@shared/svelte/Modules/CloudinaryImageService";

  // components
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { OneWayMessageEntity } from "@shared/services/event_tracking/entities/components/one_way_message_entity";

  // stores
  import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";

  // props
  export let distributor;
  export let message;

  // functions
  const imageLoadFailed = _event => {
    distributor.cloudinary_image_url = null;
  };

  const formatFromDate = dateString => {
    const date = new Date(dateString + "T12:00:00Z");
    const options: Intl.DateTimeFormatOptions = { year: "numeric", month: "short", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const closeDrawer = () => {
    open = false;

    trackClick(
      "one_way_message_x_closed",
      new OneWayMessageEntity({
        message_id: message.messageId,
      }),
    );

    if (!!localStorage.getItem(`ohlq_message_${message.id}_${$CurrentUserStore.id}_seen`)) return;
    localStorage.setItem(
      `ohlq_message_${message.id}_${$CurrentUserStore.id}_seen`,
      new Date().toISOString(),
    );
  };

  const handleTriggerClick = () => {
    const entityType = open ? "one_way_message_cancel_opened" : "one_way_message_opened";
    trackClick(
      entityType,
      new OneWayMessageEntity({
        message_id: message.messageId,
      }),
    );
    open = !open;
  };

  // data
  const { trackClick } = EventTracking;
  const panelTitle = "Message from " + distributor.name;
  let open = false;
</script>

<style lang="scss">
  .custom-alert-wrapper > :global(.craft-alert > .content > .message > p) {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
</style>

<div class="custom-alert-wrapper fizz-stack-16" data-testid="one-way-message-notif">
  <Alert title="" iconName={MegaphoneSolid} class="one-way-message-notif">
    <Text size="sm" semibold>Announcement:</Text>
    <Text size="sm">
      {message.text}
    </Text>
    <svelte:fragment slot="actions">
      <DrawerTrigger
        variant="right"
        id="open-ohlq-notification"
        label="Read More"
        triggerClick={handleTriggerClick}
        triggerSize="sm"
      />
    </svelte:fragment>
  </Alert>
</div>

<TaskPanel
  id="one-way-message"
  title={panelTitle}
  bind:open
  primaryLabel="Close"
  primaryClick={closeDrawer}
  secondaryLabel={null}
>
  <div class="flex flex-col gap-8">
    <div class="fizz-grid-center">
      {#if distributor.cloudinary_image_url}
        <img
          on:error={imageLoadFailed}
          class="logo"
          src={CloudinaryImageService.getUrl(distributor.cloudinary_image_url, 75, 75)}
          alt="Logo"
        />
      {:else}
        <Icon
          type="DistributorLogoPlaceholder"
          height={72}
          width={72}
          extraClassNames="fizz-align-self-center"
        />
      {/if}
    </div>

    <Heading as="h3" size="h3" class="fizz-text-center fizz-stack-8 fizz-truncate"
      >From {distributor.name}
    </Heading>
    <Text class="fizz-text-center fizz-stack-16">{moment(message?.fromDate).fromNow()}</Text>
    <Text semibold>Effective</Text>
    <Text class="fizz-stack-16"
      >{formatFromDate(message.fromDate) + " - " + formatFromDate(message.toDate)}</Text
    >
    <Text semibold>Announcement:</Text>
    <Text>{message.text}</Text>
  </div>
</TaskPanel>
